import {getPortal} from "../index"
import {FINISH_UPLOAD, START_UPLOAD} from "../documents"

// SELECTORS
export const getPortalUploads = (state) => getPortal(state).uploads

// REDUCER
export default (
  state = [],
  action
) => {
  switch (action.type) {
    case FINISH_UPLOAD:
      return state.filter(id => id !== action.id)
    case START_UPLOAD:
      return [...state, action.document.id]
    default:
      return state
  }
}
